import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import getCapacityCheckData from '@shopDetails/selectors/getCapacityCheckData';
import getAcceptsPreOrder from '@core/reducers/shop/selectors/getAcceptsPreOrder';
import getShopIsOpen from '@core/reducers/shop/selectors/getShopIsOpen';

import { getShopBusinessType } from '@shopDetails/selectors';
import CapacityCheck from './CapacityCheck';

const mapStateToProps = createStructuredSelector({
  capacityCheck: getCapacityCheckData,
  acceptsPreOrder: getAcceptsPreOrder,
  businessType: getShopBusinessType,
  shopIsOpen: getShopIsOpen,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CapacityCheck);
